import { Expose } from 'class-transformer'

export class Retailer {
  static type = 'retailer'

  type = Retailer.type

  guid?: string

  name?: string

  @Expose({ name: 'label_requirement' })
  labelRequirement?: string
}
